export default {
  toasts: {
    printing: 'Udskriver...',
    print_failed: 'Udskrivning mislykkedes. Prøv igen',
    orders: {
      print_one: 'Udskriver {{count}} kvittering: Ordre <strong>#{{orderNumber}}</strong>...',
      print_other: 'Udskriver {{count}} kvitteringer: Ordre <strong>#{{orderNumber}}</strong>...',
    },
  },
};
